import { useState } from "react";

const faqs = [
  {
    question: "牛奶片和普通奶片有什么区别？",
    answer: "牛奶片是以纯牛奶或奶粉为主要原料制成的片状乳制品，其核心成分是乳粉，奶含量通常在80%以上。而普通奶片可能添加了更多植脂末、淀粉等辅料，奶含量相对较低。牛奶片的钙含量通常更高，口感也更纯正浓郁。选购时建议查看配料表，优先选择乳粉排在第一位的产品。",
  },
  {
    question: "儿童每天吃多少牛奶片合适？",
    answer: "根据中国居民膳食指南建议，3-6岁儿童每日推荐钙摄入量为600mg，7-10岁为800mg。一般每片牛奶片含钙量约在50-80mg之间，建议儿童每天食用2-4片即可，不宜过量。同时要注意，牛奶片不能替代正常饮食和牛奶，应作为营养补充零食适量食用。",
  },
  {
    question: "牛奶片哪个牌子好？如何选择？",
    answer: "选择牛奶片品牌时，建议从以下四个维度综合考虑：一看品牌信誉，选择有正规生产资质和市场口碑的品牌；二看奶源产地，新西兰、澳洲、内蒙古等优质奶源带的产品品质更稳定；三看成分配料，配料表越简单越好，优先选择无添加蔗糖、无人工色素的产品；四看用户评价，参考真实消费者的使用反馈。",
  },
  {
    question: "进口牛奶片和国产牛奶片哪个更好？",
    answer: "进口牛奶片和国产牛奶片各有优势。进口牛奶片的奶源通常来自自然环境更优越的牧场，品质标准较高，但价格也相应更贵。国产优质牛奶片的性价比更高，近年来生产工艺和质量标准也在不断提升。选择关键在于看具体产品的奶源、配料和认证，而非单纯以产地判断。牛奶片库建议您根据预算和需求综合考虑。",
  },
  {
    question: "无糖牛奶片真的不含糖吗？适合糖尿病人食用吗？",
    answer: "根据国家标准，每100g食品中含糖量不超过0.5g即可标注为'无糖'。无糖牛奶片通常使用赤藓糖醇、木糖醇等天然代糖来替代蔗糖，零GI值不升血糖，糖尿病人可以适量食用。但需注意，无糖不代表无热量，牛奶片中的乳糖和脂肪仍含有热量，建议控制每日摄入量。",
  },
  {
    question: "牛奶片可以替代牛奶吗？",
    answer: "牛奶片不能完全替代液态牛奶。虽然牛奶片保留了牛奶中的大部分钙质和蛋白质，但在加工过程中，部分水溶性维生素（如维生素B族）会有所损失。此外，液态牛奶的水分含量高达87%左右，这是牛奶片无法替代的。建议将牛奶片作为日常营养补充零食，仍需保证每天饮用足量的液态奶。",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: "var(--font-heading)" }}>
            常见问题解答
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            关于牛奶片选购和食用的常见疑问，我们为您一一解答
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-100 overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(index)}
                className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-medium text-foreground-900 pr-6">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? "rotate-180" : ""}`}>
                  <i className="ri-arrow-down-s-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}